module.exports = __webpack_public_path__ + "static/transactionalemail-punctuation-do-d4019fcb52a074f2dcba5764931f8723.png";